<template>
  <div class="message-box">
    <b-modal ref="modal-window" :title="$t('object.monitoring.title-comment')" size="lg modal-fullscreen-xxl-down" modal-class="message-box-modal">
      <template #modal-body>
        <div v-for="(row, index) in list" :index="index">
          <div class="row">
            <label class="col-6"><b>{{ row.user_name }}</b></label>
            <div class="col-6 text-end">
              <span class="badge rounded-pill bg-primary" v-if="row.status == true">
                {{ $t('object.monitoring.active') }}
              </span>
              <span class="badge rounded-pill bg-warning text-dark" v-if="row.status == false">
                {{ $t('object.monitoring.disabled') }}
              </span>
              <label class="ps-2">{{ formatDate(row.created_at) }}</label>
            </div>
          </div>
          <label>{{ row.comment }}</label>
          <hr/>
        </div>

        <Textarea
          v-model="comment"
          :label="$t('client.comment')"
          :rows="3"
          :error="v$.comment.$error ? $t('object.error.actionComment') : ''"
        />
      </template>

      <template #modal-footer>
        <span class="btn btn-secondary" @click="close()">{{ $t('client.cancel') }}</span>
        <span class="btn btn-primary" @click="submit()">{{ $t('client.create') }}</span>
      </template>
    </b-modal>
  </div>
</template>

<script src="./ShowObjectComment.js"></script>
